import { render, staticRenderFns } from "./P021.vue?vue&type=template&id=bc1efe98"
import script from "./P021.vue?vue&type=script&lang=js"
export * from "./P021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports